import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { combineLatest } from "rxjs";
import { FormBuilder, FormGroup, Validators, FormArray } from "@angular/forms";
import { TaskStep } from "src/app/data/models/task-step.model";
import { PetitionerService } from "src/app/services/petitioner.service";
import { RfeTask } from "src/app/data/models/rfe-task.model";
import * as fromTask from "src/app/modules/superTask/task-state/reducers/task.reducer";
import { ToastrService } from "ngx-toastr";
import { ImagilityBaseResponse } from "../../../../data/models/response.model";
import { ActivatedRoute, Router } from "@angular/router";
import * as RolesRouteMap from "src/app/data/constants/roles";
import * as Task from "./../../task-state/actions/task.actions";
import { SubTask, SuperTask } from "app-models";

@Component({
  selector: "app-rfe-tab",
  templateUrl: "./rfe-tab.component.html",
  styleUrls: ["./rfe-tab.component.scss"],
})
export class RfeTabComponent implements OnInit {
  rfeTabForm: FormGroup;
  stepsData: TaskStep[];

  taskId;
  taskType = "RFE";
  taskTypeDetails = null;
  isOutsideImagility;
  petitionId;
  userName;
  noticeNumber;
  SubTaskOverView: SubTask;
  superTaskDetails: SuperTask;
  index: number = null;
  toggleStatus = "subTaskDetails";
  lastIndex = -1;

  constructor(
    private fb: FormBuilder,
    private petitionerService: PetitionerService,
    private store: Store<fromTask.State>,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.rfeTabForm = this.fb.group({});
  }

  ngOnInit() {
    combineLatest([
      this.store.select(fromTask.getSuperTask),
      this.store.select(fromTask.getRFESubTask),
    ]).subscribe(([superTask, rfeSubTask]) => {
      this.SubTaskOverView = rfeSubTask;
      this.store.dispatch(
        new Task.SetActiveSubTaskIndex(this.SubTaskOverView.id)
      );
      this.superTaskDetails = superTask;
      this.taskId = this.SubTaskOverView.id;
      //console.log("$$$$ SubTaskOverView",this.SubTaskOverView,'Super Task Details:',this.superTaskDetails)
      this.getTaskDetails();
    });
  }

  getTaskDetails() {
    this.petitionerService.getTask(this.taskId).subscribe((response: any) => {
      if (response) {
        //console.log('response:',response);
        this.store.dispatch(new Task.SetRfeSubTaskDetails(response));
        this.taskId = response.id;

        this.petitionId = response.petitionId;
        sessionStorage.setItem("petitionId", this.petitionId);
        // this.task = {
        //   id: response.id,
        //   authorizedSignatoryId: response.signatoryId,
        //   beneficiaryId: response.beneficiaryId,
        //   companyId: response.companyId,
        //   petitionTypeCode: response.taskTypeDetails && response.taskTypeDetails['petitionType'] ?
        //     response.taskTypeDetails['petitionType'] : null,
        //   processingType: response.processingType,
        //   serviceCenterId: response.serviceCenterId,
        //   visaTypeCode: response.taskTypeDetails && response.taskTypeDetails['visaType'] ?
        //     response.taskTypeDetails['visaType'] : null,
        //   attorneyId: response.attorneyId,
        //   preparerAttorneyId: response.preparerAttorneyId,
        //   immSpecialistId: response.immSpecialistId,
        //   immigrantTypeCode: response.immigrantTypeCode,
        //   taskTypeCode: response.taskTypeCode,
        //   isCaseTransferred: response.isCaseTransferred,
        //   isAttorneySame: response.isAttorneySame
        //   // questionAndResponseDTO: response['questionAndResponseDTO']
        // };
        this.noticeNumber = response.noticeNumber;
        this.stepsData = response.taskStepDetails;
        this.taskTypeDetails = response.taskTypeDetails;
        this.userName = `${response.beneficiaryDetails.firstName} ${response.beneficiaryDetails.lastName}`;
        this.isOutsideImagility = response.isOutsideImagility ? true : false;
      }
    });
    this.toggleStatus = "subTaskDetails";
  }

  saveTask() {
    console.log("rfeTask tab form", this.rfeTabForm, this.superTaskDetails);
    let payload = this.rfeTabForm.value;
    // if(this.selectedSubTask === 'PETITION' && payload.hasOwnProperty('questionAndResponseDTO')){
    //   payload['questionAndResponseDTO'].forEach((item) => {
    //     item.answer = item.answer? 1:0
    //   });

    // }
    let immigrantType = this.superTaskDetails.immigrationType.code;
    // console.log("payload",payload);
    payload.beneficiaryId = this.superTaskDetails.beneficiaryId;
    payload.companyId = this.superTaskDetails.companyId;
    payload.petitionType = this.superTaskDetails.petitionType.code;
    payload.visaType = this.superTaskDetails.visaType.code;
    payload.superTaskId = this.superTaskDetails.superTaskId;
    payload.id = this.SubTaskOverView.id;
    payload.taskTypeCode = this.SubTaskOverView.taskTypeCode;
    payload.isOutsideImagility = this.SubTaskOverView.isOutside ? 1 : 0;
    payload.isCaseTransferred = payload.isCaseTransferred ? 1 : 0;
    payload.isAttorneySame = payload.isAttorneySame ? 1 : 0;
    this.petitionerService
      .saveTask(payload, immigrantType)
      .subscribe((response: ImagilityBaseResponse) => {
        if (response) {
          let id = response.data["superTaskId"];
          this.toastr.success(response.message, 'Success');
          this.store.dispatch(new Task.SetRfeSubTaskDetails(response.data));
          // this.rfeTabForm.reset();
          // this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/task-details/${id}/rfe`]);
          // this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/task-details`, id]);
        }
      });
  }
  toggleMode(mode) {
    this.toggleStatus = mode;
  }
  closePanel() {
    this.index = this.lastIndex--;
  }
}
